<template>
<div>
	<template v-if="calendarView == 'daily' && hasModulePermWrite('Calendar')">
		<button v-if="!dayIsPublished"
			type="button"
			v-on:click="$emit('publish')"
			:disabled="scheduleRows.length == 0"
			class="btn btn-primary">
			<i class="fa fa-paper-plane"></i>
			Publish Day
		</button>
		<template v-else>
			<button class="btn btn-light mr-1" v-on:click="$emit('unpublish')" type="button">
				<i class="fa fa-pencil-alt"></i>
				Un-publish
			</button>
			<button class="btn btn-primary" v-on:click="$emit('sendNotices')" type="button">
				<i class="fa fa-paper-plane"></i>
				Send Notices
			</button>
		</template>
		<button v-if="!scheduleLogVisible" class="btn btn-light ml-1" type="button" v-on:click="openScheduleLogs">
			View Schedule Log
		</button>
		<modal-dialog
			:modal-visible="scheduleLogVisible"
			:title="'Schedule Logs for '+selectedDate"
			:submit-visible="false"
			cancel-button-text="Done"
			v-on:closeModal="scheduleLogVisible = false">
			<ul class="list-group">
				<li v-for="log in mutatedScheduleLogs" class="list-group-item">
					<span class="text-muted">{{ formatDateTimeToLocal(log.created_at) }}: </span>{{ log.action_type }} by {{ log.user }}
				</li>
			</ul>
		</modal-dialog>
	</template>
</div>
</template>
<script type="text/javascript">

import ModalDialog from "@/components/ModalDialog"

export default {
	name: "PublishControls",
	components: {
		ModalDialog
	},
	props: [
		"calendarView",
		"dayIsPublished",
		"scheduleRows",
		"selectedDate"
	],
	data() {
		return {
			scheduleLogVisible: false,
			scheduleLogs: [],
			actionTypeMap: {

			}
		}
	},
	computed: {
		mutatedScheduleLogs() {
			let vm = this

			return this.scheduleLogs.map(log => {
				log.user = log.User.first_name+" "+log.User.last_name

				return log
			})
		}
	},
	methods: {
		openScheduleLogs() {
			let vm = this
			this.getJSON("ScheduleLog/get",{
				filters: [["schedule_date",this.selectedDate]],
				include: [{model: "User",fields: ["first_name","last_name"]}]
			}).then(response => {
				if (response.success) {
					vm.scheduleLogVisible = true
					vm.scheduleLogs = response.data
				}
			})
		}
	}
}	
</script>